<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    v-if="me"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-4 pe-4 pt-5 pb-2">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <v-slide-x-transition>
          <h2 class="app-title text--primary"><span>Trayllo </span><span> - Painel</span></h2>
        </v-slide-x-transition>
      </router-link>
    </div>
    <!-- Progress Bar -->
     <div class=" align-center justify-center pl-4 pr-4 pt-2 pb-2" v-if="progress>=0">
      <strong class="d-block">Limite do plano</strong>
      <span class="text-danger mb-2 d-block">{{progress}}% do limite atingido</span>
       <v-progress-linear
       :value="progress"
       height="4"
       color="warning"
       ></v-progress-linear>
      </div>
    <shops-selector class="shops"></shops-selector>
    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link
        title="Pedidos"
        :to="{ name: 'pedidos' }"
        :icon="icons.mdiOrderBoolDescendingVariant"
      ></nav-menu-link>
      <!-- <nav-menu-link
        title="Produtos Vendidos"
        :to="{ name: 'produtos-vendidos'}"
        :icon="icons.mdiCreditCardOutline"
      ></nav-menu-link> -->
      <nav-menu-link title="Carrinhos" :to="{ name: 'carrinhos' }" :icon="icons.mdiCartOutline"></nav-menu-link>
      <nav-menu-link title="Minha conta" :to="{ name: 'conta' }" :icon="icons.mdiAccountCircleOutline"></nav-menu-link>
      <nav-menu-link
        title="Conectar Loja Tray"
        :to="{ name: 'tray' }"
        :icon="icons.mdiStorefrontOutline"
      ></nav-menu-link>
      <nav-menu-link title="Conectar Trello" :to="{ name: 'trello' }" :icon="icons.mdiTrello"></nav-menu-link>
      <nav-menu-link title="Conectar Telegram" :to="{ name: 'telegram' }" :icon="icons.mdiTelegram"></nav-menu-link>
      <nav-menu-link title="Conectar Whatsapp" :to="{ name: 'whatsapp' }" :icon="icons.mdiWhatsapp"></nav-menu-link>
      <nav-menu-link title="Assinatura" :to="{ name: 'subscription' }" :icon="icons.mdiCrown"></nav-menu-link>
      <!-- <nav-menu-link
        title="Cards"
        :to="{ name: 'cards' }"
        :icon="icons.mdiCreditCardOutline"
      ></nav-menu-link>
      <nav-menu-link
        title="Tables"
        :to="{ name: 'simple-table' }"
        :icon="icons.mdiTable"
      ></nav-menu-link>
      <nav-menu-link
        title="Form Layouts"
        :to="{ name: 'form-layouts' }"
        :icon="icons.mdiFormSelect"
      ></nav-menu-link> -->
    </v-list>
    <!-- <a
      href="https://themeselection.com/products/materio-vuetify-vuejs-admin-template"
      target="_blank"
      rel="nofollow"
    >
      <v-img
        :src="require(`@/assets/images/pro/upgrade-banner-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
        alt="upgrade-banner"
        transition="scale-transition"
        class="upgrade-banner mx-auto"
        max-width="230"
      ></v-img>
    </a> -->
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiCartOutline,
  mdiAccountCogOutline,
  mdiOrderBoolDescendingVariant,
  mdiAccountCircleOutline,
  mdiStorefrontOutline,
  mdiTrello,
  mdiTelegram,
  mdiAccountCheck,
  mdiCrown,
  mdiWhatsapp,
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'
import ShopsSelector from '../../../components/ShopsSelector.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    ShopsSelector,
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    progress() {
      return this.$store.state.me.data.month_sales.total
        ? Math.round((this.$store.state.me.data.month_sales.total / this.$store.state.me.data.subscription.plan.limit) * 100)
        : 0
    },
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiCartOutline,
        mdiOrderBoolDescendingVariant,
        mdiAccountCircleOutline,
        mdiStorefrontOutline,
        mdiTrello,
        mdiTelegram,
        mdiAccountCheck,
        mdiCrown,
        mdiWhatsapp,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.shops {
  padding: 0 15px;
}
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
